<div class="d-flex justify-content-end my-2">
  <app-export-data
    id="data-analysis-export-data"
    [JSONdata]="dataJSON"
    [fileName]="'Series table'"
    [module]="'series_data_table'"
    [buttonDisabled]="loading"
    class="pr-md-1 mr-20">
  </app-export-data>
</div>

@if (!dataTable) {
  <app-loading-and-no-data-template
    [height]="400"
    [isLoading]="!dataTable"
  ></app-loading-and-no-data-template>
}

<div class="series-table-container">
  <table mat-table [dataSource]="dataTable | async" matSort matSortActive="time" matSortDirection="asc"  (matSortChange)="sortData($event)">

    @for (title of titles; track $index; let i = $index) {
      <ng-container [matColumnDef]="title">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="title" class="mat-header-cell">{{ titlesNames[i] }}</th>
        <td mat-cell *matCellDef="let data" class="mat-cell p-2 time-cell">
          @if (title === 'time') {
            {{ data.timestamp | dateTimeFormatPipe: 'dmyt' }}
          } @else {
            {{ data[title] !== '-' ? (data[title] | number: getNumberFormat(title) | customNumberFormat) : data[title] }}
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="titles; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: titles"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
</div>